// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__Nuku5","menu":"Nav_menu__3ZTNn","logoName":"Nav_logoName__2FaWU","contact":"Nav_contact__1x8OA","sub-menus":"Nav_sub-menus__uq_L5"};